import { CREATE_NEW_CHAT_CONVERSATION_REQUEST, createNewChatConversationSuccess, createNewChatConversationFailure } from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

export function createNewChatConversationEpic(action$, store$, { ChatRepository }) {
    return action$.pipe(
        ofType(CREATE_NEW_CHAT_CONVERSATION_REQUEST),
        mergeMap(action => from(
            ChatRepository.create( action.payload )
                .then(( conversation ) => createNewChatConversationSuccess({ conversation }))
                .catch(error => createNewChatConversationFailure(error)),
        )),
    );
}
